
const styles = (theme) => ({
  ...theme.global,
 
})
export default styles
